// ═══════════════════════════════════════════════════════════════
// Timesheet UI Prototype — Mock Data
// Realistic scaffolding domain data for UI development.
// ═══════════════════════════════════════════════════════════════

import {
  WorkOrderOption,
  ScaffoldTaskOption,
  AssetOption,
  WorkerOption,
  TimesheetDay,
  TimesheetDayStatus,
  VehicleType,
  PlannerActivityMock,
  WorkEntry,
} from "../types/timesheetTypes";

// ── Work Orders ──

export const MOCK_WORK_ORDERS: WorkOrderOption[] = [
  { id: "wo-001", number: "WO-0042", clientName: "Acme Corp", siteName: "CBD Tower Site", jobNumber: "JOB-2026-036" },
  { id: "wo-002", number: "WO-0043", clientName: "Beta Industries", siteName: "Factory North", jobNumber: "JOB-2026-037" },
  { id: "wo-003", number: "WO-0044", clientName: "Gamma Energy", siteName: "Turbine Hall", jobNumber: "JOB-2026-038" },
  { id: "wo-004", number: "WO-0045", clientName: "Acme Corp", siteName: "Warehouse B", jobNumber: "JOB-2026-036" },
  { id: "wo-005", number: "WO-0046", clientName: "Gamma Energy", siteName: "Turbine Hall", jobNumber: "JOB-2026-038" },
  { id: "wo-006", number: "WO-0047", clientName: "Beta Industries", siteName: "Factory North", jobNumber: "JOB-2026-037" },
];

// ── Scaffold Tasks (only Completed status shown in picker) ──

export const MOCK_SCAFFOLD_TASKS: ScaffoldTaskOption[] = [
  { id: "st-001", scaffoldId: "scf-001", scaffoldNumber: "SCF-0012", taskName: "Erect main tower", actionIntent: "Erect", workOrderId: "wo-001" },
  { id: "st-002", scaffoldId: "scf-002", scaffoldNumber: "SCF-0015", taskName: "Modify platform A", actionIntent: "Modify", workOrderId: "wo-001" },
  { id: "st-003", scaffoldId: "scf-003", scaffoldNumber: "SCF-0018", taskName: "Erect access scaffold", actionIntent: "Erect", workOrderId: "wo-002" },
  { id: "st-004", scaffoldId: "scf-004", scaffoldNumber: "SCF-0022", taskName: "Dismantle edge protection", actionIntent: "Dismantle", workOrderId: "wo-002" },
  { id: "st-005", scaffoldId: "scf-005", scaffoldNumber: "SCF-0025", taskName: "Erect turbine scaffold", actionIntent: "Erect", workOrderId: "wo-003" },
  { id: "st-006", scaffoldId: "scf-006", scaffoldNumber: "SCF-0028", taskName: "Modify containment", actionIntent: "Modify", workOrderId: "wo-003" },
  { id: "st-007", scaffoldId: "scf-007", scaffoldNumber: "SCF-0031", taskName: "Erect loading bay", actionIntent: "Erect", workOrderId: "wo-004" },
  { id: "st-008", scaffoldId: "scf-008", scaffoldNumber: "SCF-0034", taskName: "Dismantle stair tower", actionIntent: "Dismantle", workOrderId: "wo-005" },
  { id: "st-009", scaffoldId: "scf-009", scaffoldNumber: "SCF-0037", taskName: "Erect birdcage scaffold", actionIntent: "Erect", workOrderId: "wo-005" },
  { id: "st-010", scaffoldId: "scf-010", scaffoldNumber: "SCF-0040", taskName: "Modify roof rails", actionIntent: "Modify", workOrderId: "wo-006" },
  { id: "st-011", scaffoldId: "scf-011", scaffoldNumber: "SCF-0043", taskName: "Erect hoist tower", actionIntent: "Erect", workOrderId: "wo-006" },
];

// ── Assets (Vehicles / Trucks) ──

export const MOCK_ASSETS: AssetOption[] = [
  { id: "asset-001", name: "Ute K001", code: "VEH-001", type: VehicleType.Ute },
  { id: "asset-002", name: "Ute K002", code: "VEH-002", type: VehicleType.Ute },
  { id: "asset-003", name: "Truck T1", code: "VEH-003", type: VehicleType.SmallTruck },
  { id: "asset-004", name: "Truck T2", code: "VEH-004", type: VehicleType.LargeTruck },
  { id: "asset-005", name: "Ute & Trailer K003", code: "VEH-005", type: VehicleType.UteAndTrailer },
];

// ── Planner Activities (today's assigned activities for current user) ──

export const MOCK_PLANNER_ACTIVITIES: PlannerActivityMock[] = [
  {
    id: "act-001",
    activityNumber: "ACT000067",
    workOrderId: "wo-001",
    workOrderNumber: "WO-0042",
    jobNumber: "JOB-2026-036",
    jobTitle: "Kalp test",
    clientName: "Kalpahari Solutions",
    siteName: "House 1001",
    siteAddress: "5 Arama Street, Nukuhau, Taupō 3330, New Zealand",
    scheduledStart: "2026-04-03T08:00:00",
    scheduledEnd: "2026-04-03T17:00:00",
    executionLines: [
      {
        id: "el-001", scaffoldId: "scf-001", scaffoldNumber: "SCF0001",
        scaffoldName: "Scaffold Around Play Area", scaffoldTaskType: "ER",
        scaffoldTaskTypeFull: "Erect", taskDescription: "Erect Structure",
        workOrderTaskId: "wot-001", scaffoldTaskId: "st-001",
      },
      {
        id: "el-002", scaffoldId: "scf-001", scaffoldNumber: "SCF0001",
        scaffoldName: "Scaffold Around Play Area", scaffoldTaskType: "GEN",
        scaffoldTaskTypeFull: "General", taskDescription: "ForkLift",
        workOrderTaskId: "wot-002", scaffoldTaskId: "st-002",
      },
      {
        id: "el-003", scaffoldId: "scf-002", scaffoldNumber: "SCF0002",
        scaffoldName: "Temp Fencing", scaffoldTaskType: "ER",
        scaffoldTaskTypeFull: "Erect", taskDescription: "NET around site",
        workOrderTaskId: "wot-003", scaffoldTaskId: "st-003",
      },
    ],
    // ACT000067 has 2 WOs from the same job
    additionalWorkOrders: [
      { id: "wo-004", number: "WO-0045", clientName: "Kalpahari Solutions" },
    ],
  },
  {
    id: "act-002",
    activityNumber: "ACT000068",
    workOrderId: "wo-002",
    workOrderNumber: "WO-0043",
    jobNumber: "JOB-2026-037",
    jobTitle: "Factory Access Scaffolding",
    clientName: "Beta Industries",
    siteName: "Factory North",
    siteAddress: "12 Totara Drive, Otumoetai, Tauranga 3110, New Zealand",
    scheduledStart: "2026-04-03T08:00:00",
    scheduledEnd: "2026-04-03T17:00:00",
    executionLines: [
      {
        id: "el-004", scaffoldId: "scf-003", scaffoldNumber: "SCF0018",
        scaffoldName: "Access Scaffold Bay 3", scaffoldTaskType: "ER",
        scaffoldTaskTypeFull: "Erect", taskDescription: "Erect access scaffold",
        workOrderTaskId: "wot-004", scaffoldTaskId: "st-004",
      },
      {
        id: "el-005", scaffoldId: "scf-004", scaffoldNumber: "SCF0022",
        scaffoldName: "Edge Protection Level 2", scaffoldTaskType: "DM",
        scaffoldTaskTypeFull: "Dismantle", taskDescription: "Dismantle edge protection",
        workOrderTaskId: "wot-005", scaffoldTaskId: "st-005",
      },
      {
        id: "el-006", scaffoldId: "scf-003", scaffoldNumber: "SCF0018",
        scaffoldName: "Access Scaffold Bay 3", scaffoldTaskType: "MO",
        scaffoldTaskTypeFull: "Modify", taskDescription: "Add handrails to Bay 3",
        workOrderTaskId: "wot-006", scaffoldTaskId: "st-006",
      },
    ],
    additionalWorkOrders: [
      { id: "wo-006", number: "WO-0047", clientName: "Beta Industries" },
    ],
  },
  {
    id: "act-003",
    activityNumber: "ACT000069",
    workOrderId: "wo-003",
    workOrderNumber: "WO-0044",
    jobNumber: "JOB-2026-038",
    jobTitle: "Turbine Hall Access",
    clientName: "Gamma Energy",
    siteName: "Turbine Hall",
    siteAddress: "78 Power Station Rd, Huntly 3700, New Zealand",
    scheduledStart: "2026-04-03T08:00:00",
    scheduledEnd: "2026-04-03T17:00:00",
    executionLines: [
      {
        id: "el-007", scaffoldId: "scf-005", scaffoldNumber: "SCF0025",
        scaffoldName: "Turbine Access Scaffold", scaffoldTaskType: "ER",
        scaffoldTaskTypeFull: "Erect", taskDescription: "Erect turbine scaffold",
        workOrderTaskId: "wot-007", scaffoldTaskId: "st-007",
      },
      {
        id: "el-008", scaffoldId: "scf-006", scaffoldNumber: "SCF0030",
        scaffoldName: "Cooling Tower Platform", scaffoldTaskType: "ER",
        scaffoldTaskTypeFull: "Erect", taskDescription: "Erect cooling tower platform",
        workOrderTaskId: "wot-008", scaffoldTaskId: "st-008",
      },
    ],
    additionalWorkOrders: [
      { id: "wo-005", number: "WO-0046", clientName: "Gamma Energy" },
    ],
  },
];

/** Get tasks for a specific activity (for task picker filtered by activity) */
export function getTasksForActivity(activityId: string): PlannerActivityMock["executionLines"] {
  const activity = MOCK_PLANNER_ACTIVITIES.find((a) => a.id === activityId);
  return activity?.executionLines || [];
}

// ── Workers ──

export const MOCK_WORKERS: WorkerOption[] = [
  { id: "user-001", name: "Harshit Joshi", role: "Supervisor" },
  { id: "user-002", name: "Que Nguyen", role: "Advanced Scaffolder" },
  { id: "user-003", name: "Allan Brooks", role: "Scaffolder" },
  { id: "user-004", name: "James Cooper", role: "Supervisor" },
  { id: "user-005", name: "Sarah Chen", role: "Advanced Scaffolder" },
  { id: "user-006", name: "Tom Parker", role: "Apprentice" },
];

// ── Current User (for field app) ──

export const MOCK_CURRENT_USER: WorkerOption = MOCK_WORKERS[0]; // Harshit Joshi, Supervisor

// ── Factory ──

let dayCounter = 0;

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}

export function generateEmptyDay(userId: string, date: string): TimesheetDay {
  const worker = MOCK_WORKERS.find((w) => w.id === userId);
  dayCounter++;
  return {
    id: `day-${dayCounter}-${generateId()}`,
    userId,
    userName: worker?.name || "Unknown",
    userRole: worker?.role || "Scaffolder",
    date,
    status: TimesheetDayStatus.Draft,
    workEntries: [],
    assetTravelEntries: [],
    consumablesNote: "",
    notes: "",
    submittedAt: null,
    createdByUserId: null,
    dailyTravelMinutes: 0,
    dailyVehicleId: null,
    dailyVehicleName: null,
    activityTravelEntries: [],
    approvedAt: null,
    approvedByUserId: null,
    rejectedAt: null,
    rejectedReason: null,
    totalJobHours: 0,
    totalStandbyMinutes: 0,
    totalBreakMinutes: 0,
    totalEffectiveHours: 0,
    totalActualWorkHours: 0,
    entryCount: 0,
  };
}

// ── Helper: get today as YYYY-MM-DD ──

export function todayString(): string {
  return new Date().toISOString().split("T")[0];
}

// ── Helper: tasks filtered by work order ──

export function getTasksForWorkOrder(workOrderId: string): ScaffoldTaskOption[] {
  return MOCK_SCAFFOLD_TASKS.filter((t) => t.workOrderId === workOrderId);
}

// ── Helper: create a work entry with all derived fields ──

function makeWorkEntry(
  wo: { id: string; number: string; client: string; site: string },
  task: { id: string; scaffoldNum: string; name: string },
  start: string, end: string, breakMin: number, standbyMin: number,
  seq: number, notes = ""
): WorkEntry {
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  const span = (eh * 60 + em) - (sh * 60 + sm);
  const effective = span - breakMin;
  const actual = effective - standbyMin;
  return {
    id: generateId(), workOrderId: wo.id, workOrderNumber: wo.number,
    scaffoldTaskId: task.id, scaffoldNumber: task.scaffoldNum, taskName: task.name,
    clientName: wo.client, siteName: wo.site,
    startTime: start, endTime: end, breakMinutes: breakMin, standbyMinutes: standbyMin,
    totalSpanMinutes: span, effectiveMinutes: effective, actualWorkMinutes: actual,
    calculatedJobMinutes: actual, calculatedJobHours: Math.round((actual / 60) * 100) / 100,
    notes, sequence: seq,
  };
}

// ── Seed data: pre-filled example days for admin list demo ──

export function generateSeedTimesheets(): TimesheetDay[] {
  const today = todayString();
  const yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];
  const twoDaysAgo = new Date(Date.now() - 2 * 86400000).toISOString().split("T")[0];
  const threeDaysAgo = new Date(Date.now() - 3 * 86400000).toISOString().split("T")[0];

  const wo1 = { id: "wo-001", number: "WO-0042", client: "Kalpahari Solutions", site: "House 1001" };
  const wo2 = { id: "wo-002", number: "WO-0043", client: "Beta Industries", site: "Factory North" };
  const wo3 = { id: "wo-003", number: "WO-0044", client: "Gamma Energy", site: "Turbine Hall" };

  return [
    // ── Harshit today (Draft, 4 entries across 2 WOs) ──
    {
      ...generateEmptyDay("user-001", today),
      workEntries: [
        makeWorkEntry(wo1, { id: "st-001", scaffoldNum: "SCF0001", name: "Scaffold Around Play Area - Erect Structure" }, "08:00", "10:30", 0, 0, 1),
        makeWorkEntry(wo1, { id: "st-002", scaffoldNum: "SCF0001", name: "Scaffold Around Play Area - ForkLift" }, "10:30", "12:00", 15, 0, 2, "Moved materials to level 2"),
        makeWorkEntry(wo1, { id: "st-003", scaffoldNum: "SCF0002", name: "Temp Fencing - NET around site" }, "12:30", "14:00", 0, 0, 3),
        makeWorkEntry(wo2, { id: "st-004", scaffoldNum: "SCF0018", name: "Access Scaffold Bay 3 - Erect access scaffold" }, "14:30", "17:00", 0, 30, 4),
      ],
      assetTravelEntries: [
        { id: generateId(), assetId: "asset-001", assetName: "Ute K001", assetCode: "VEH-001",
          assetType: VehicleType.Ute, tripType: "Travel" as const, startKM: 12450, endKM: 12530, totalKM: 80,
          startKMPhotoUrl: null, endKMPhotoUrl: null,
          createdByUserId: "user-001", createdByUserName: "Harshit Joshi", distributions: [] },
        { id: generateId(), assetId: "asset-003", assetName: "Truck T1", assetCode: "VEH-003",
          assetType: VehicleType.SmallTruck, tripType: "Cartage" as const, startKM: 1258, endKM: 2586, totalKM: 1328,
          startKMPhotoUrl: null, endKMPhotoUrl: null,
          createdByUserId: "user-001", createdByUserName: "Harshit Joshi", distributions: [] },
        { id: generateId(), assetId: "asset-004", assetName: "Truck T2", assetCode: "VEH-004",
          assetType: VehicleType.LargeTruck, tripType: "Cartage" as const, startKM: 5200, endKM: 5480, totalKM: 280,
          startKMPhotoUrl: null, endKMPhotoUrl: null,
          createdByUserId: "user-001", createdByUserName: "Harshit Joshi", distributions: [] },
      ],
      dailyTravelMinutes: 120, dailyVehicleId: "asset-001", dailyVehicleName: "Ute K001",
      activityTravelEntries: [
        { id: generateId(), activityId: "act-001", activityNumber: "ACT000067", vehicleId: "asset-001", vehicleName: "Ute K001", travelMinutes: 60 },
        { id: generateId(), activityId: "act-002", activityNumber: "ACT000068", vehicleId: "asset-003", vehicleName: "Truck T1", travelMinutes: 45 },
      ],
      consumablesNote: "2 sheets ply, 5m safety wrap",
      totalJobHours: 7.25, totalStandbyMinutes: 30, totalBreakMinutes: 15,
      totalEffectiveHours: 7.50, totalActualWorkHours: 7.00, entryCount: 4,
    },

    // ── Que today (Submitted) ──
    {
      ...generateEmptyDay("user-002", today),
      workEntries: [
        makeWorkEntry(wo1, { id: "st-002", scaffoldNum: "SCF-0015", name: "Modify platform A" }, "07:30", "16:30", 30, 0, 1),
      ],
      dailyTravelMinutes: 90, dailyVehicleId: "asset-001", dailyVehicleName: "Ute K001",
      activityTravelEntries: [],
      status: TimesheetDayStatus.Submitted, submittedAt: new Date().toISOString(),
      totalJobHours: 8.50, totalStandbyMinutes: 0, totalBreakMinutes: 30,
      totalEffectiveHours: 8.50, totalActualWorkHours: 8.50, entryCount: 1,
    },

    // ── Harshit yesterday (Submitted) ──
    {
      ...generateEmptyDay("user-001", yesterday),
      workEntries: [
        makeWorkEntry(wo3, { id: "st-005", scaffoldNum: "SCF-0025", name: "Erect turbine scaffold" }, "08:00", "12:30", 15, 15, 1),
        makeWorkEntry(wo2, { id: "st-008", scaffoldNum: "SCF-0034", name: "Dismantle stair tower" }, "13:30", "16:30", 0, 0, 2),
      ],
      assetTravelEntries: [
        { id: generateId(), assetId: "asset-003", assetName: "Truck T1", assetCode: "VEH-003",
          assetType: VehicleType.SmallTruck, tripType: "Cartage" as const, startKM: 45200, endKM: 45265, totalKM: 65,
          startKMPhotoUrl: null, endKMPhotoUrl: null,
          createdByUserId: "user-001", createdByUserName: "Harshit Joshi", distributions: [] },
      ],
      dailyTravelMinutes: 60, dailyVehicleId: "asset-002", dailyVehicleName: "Ute K002",
      activityTravelEntries: [],
      status: TimesheetDayStatus.Submitted, submittedAt: new Date(Date.now() - 86400000).toISOString(),
      totalJobHours: 7.00, totalStandbyMinutes: 15, totalBreakMinutes: 15,
      totalEffectiveHours: 7.25, totalActualWorkHours: 7.00, entryCount: 2,
    },

    // ── Allan 2 days ago (Approved) ──
    {
      ...generateEmptyDay("user-003", twoDaysAgo),
      workEntries: [
        makeWorkEntry(wo1, { id: "st-001", scaffoldNum: "SCF0001", name: "Erect Structure" }, "08:00", "16:00", 30, 60, 1),
      ],
      dailyTravelMinutes: 45, dailyVehicleId: "asset-001", dailyVehicleName: "Ute K001",
      activityTravelEntries: [],
      status: TimesheetDayStatus.Approved, approvedAt: new Date(Date.now() - 86400000).toISOString(), approvedByUserId: "admin-001",
      totalJobHours: 6.50, totalStandbyMinutes: 60, totalBreakMinutes: 30,
      totalEffectiveHours: 7.50, totalActualWorkHours: 6.50, entryCount: 1,
    },

    // ── Sarah 3 days ago (Rejected) ──
    {
      ...generateEmptyDay("user-005", threeDaysAgo),
      workEntries: [
        makeWorkEntry(wo2, { id: "st-004", scaffoldNum: "SCF0018", name: "Erect access scaffold" }, "09:00", "15:00", 30, 0, 1),
      ],
      dailyTravelMinutes: 30, dailyVehicleId: "asset-002", dailyVehicleName: "Ute K002",
      activityTravelEntries: [],
      status: TimesheetDayStatus.Rejected, rejectedAt: new Date(Date.now() - 2 * 86400000).toISOString(), rejectedReason: "Missing break entry — please update actual break time",
      totalJobHours: 5.50, totalStandbyMinutes: 0, totalBreakMinutes: 30,
      totalEffectiveHours: 5.50, totalActualWorkHours: 5.50, entryCount: 1,
    },
  ];
}

// ═══════════════════════════════════════════════════════════════
// Rate Matrices (read-only reference for future invoicing)
// ═══════════════════════════════════════════════════════════════

export interface LabourRate {
  role: string;
  taskType: string;
  ratePerHour: number;
  clientOverride?: string; // null = tenant default
}

export const MOCK_LABOUR_RATES: LabourRate[] = [
  // Tenant defaults
  { role: "Supervisor", taskType: "Erect", ratePerHour: 48.88 },
  { role: "Supervisor", taskType: "Modify", ratePerHour: 48.88 },
  { role: "Supervisor", taskType: "Dismantle", ratePerHour: 48.88 },
  { role: "Supervisor", taskType: "General", ratePerHour: 45.00 },
  { role: "Advanced Scaffolder", taskType: "Erect", ratePerHour: 42.50 },
  { role: "Advanced Scaffolder", taskType: "Modify", ratePerHour: 42.50 },
  { role: "Advanced Scaffolder", taskType: "Dismantle", ratePerHour: 42.50 },
  { role: "Advanced Scaffolder", taskType: "General", ratePerHour: 40.00 },
  { role: "Scaffolder", taskType: "Erect", ratePerHour: 35.00 },
  { role: "Scaffolder", taskType: "Modify", ratePerHour: 35.00 },
  { role: "Scaffolder", taskType: "Dismantle", ratePerHour: 35.00 },
  { role: "Scaffolder", taskType: "General", ratePerHour: 32.00 },
  { role: "Apprentice", taskType: "Erect", ratePerHour: 22.00 },
  { role: "Apprentice", taskType: "Dismantle", ratePerHour: 22.00 },
  { role: "Apprentice", taskType: "General", ratePerHour: 20.00 },
  // Client overrides
  { role: "Supervisor", taskType: "Erect", ratePerHour: 55.00, clientOverride: "Beta Industries" },
  { role: "Advanced Scaffolder", taskType: "Erect", ratePerHour: 47.00, clientOverride: "Beta Industries" },
];

export interface CartageRate {
  vehicleType: string;
  distanceBand: string;
  ratePerKM: number;
}

export const MOCK_CARTAGE_RATES: CartageRate[] = [
  { vehicleType: "Ute", distanceBand: "Local (<50km)", ratePerKM: 0.62 },
  { vehicleType: "Ute", distanceBand: "Regional (50-200km)", ratePerKM: 0.55 },
  { vehicleType: "Ute", distanceBand: "Long Distance (>200km)", ratePerKM: 0.48 },
  { vehicleType: "Ute & Trailer", distanceBand: "Local (<50km)", ratePerKM: 0.85 },
  { vehicleType: "Ute & Trailer", distanceBand: "Regional (50-200km)", ratePerKM: 0.75 },
  { vehicleType: "Ute & Trailer", distanceBand: "Long Distance (>200km)", ratePerKM: 0.65 },
  { vehicleType: "Small Truck", distanceBand: "Local (<50km)", ratePerKM: 1.10 },
  { vehicleType: "Small Truck", distanceBand: "Regional (50-200km)", ratePerKM: 0.95 },
  { vehicleType: "Small Truck", distanceBand: "Long Distance (>200km)", ratePerKM: 0.85 },
  { vehicleType: "Large Truck", distanceBand: "Local (<50km)", ratePerKM: 1.45 },
  { vehicleType: "Large Truck", distanceBand: "Regional (50-200km)", ratePerKM: 1.25 },
  { vehicleType: "Large Truck", distanceBand: "Long Distance (>200km)", ratePerKM: 1.10 },
];

export interface PrepChargeRule {
  minHours: number;
  maxHours: number | null;
  chargeableHours: number;
  label: string;
}

export const MOCK_PREP_CHARGE_RULES: PrepChargeRule[] = [
  { minHours: 7, maxHours: null, chargeableHours: 1.0, label: "≥ 7 hours on site" },
  { minHours: 5, maxHours: 7, chargeableHours: 0.75, label: "≥ 5 hours on site" },
  { minHours: 3, maxHours: 5, chargeableHours: 0.5, label: "≥ 3 hours on site" },
  { minHours: 0, maxHours: 3, chargeableHours: 0.25, label: "< 3 hours on site" },
];

// ═══════════════════════════════════════════════════════════════
// Bulk Fill — Activities with full crew + asset assignments
// ═══════════════════════════════════════════════════════════════

export interface BulkFillActivity {
  activity: PlannerActivityMock;
  assignedCrew: WorkerOption[];
  assignedAssets: AssetOption[];
}

export const MOCK_BULK_FILL_ACTIVITIES: BulkFillActivity[] = [
  {
    activity: MOCK_PLANNER_ACTIVITIES[0], // ACT000067 — Vhoo1 (Ute K001) + Vhoo2 (Truck T1)
    assignedCrew: [
      MOCK_WORKERS[0], MOCK_WORKERS[1], MOCK_WORKERS[2], MOCK_WORKERS[3],
      MOCK_WORKERS[4], MOCK_WORKERS[5], // 6 crew
    ],
    assignedAssets: [MOCK_ASSETS[0], MOCK_ASSETS[2]], // Ute K001 + Truck T1
  },
  {
    activity: MOCK_PLANNER_ACTIVITIES[1], // ACT000068 — Vhoo1 (Ute K001) + Vhoo2 (Truck T1)
    assignedCrew: [
      MOCK_WORKERS[0], MOCK_WORKERS[1], MOCK_WORKERS[2],
      MOCK_WORKERS[3], MOCK_WORKERS[4], MOCK_WORKERS[5],
      { id: "user-007", name: "Mike Wilson", role: "Scaffolder" },
      { id: "user-008", name: "Dave Rogers", role: "Scaffolder" },
    ],
    assignedAssets: [MOCK_ASSETS[0], MOCK_ASSETS[2]], // Ute K001 + Truck T1
  },
  {
    activity: MOCK_PLANNER_ACTIVITIES[2], // ACT000069 — Vhoo1 (Ute K001) + Vhoo3 (Truck T2)
    assignedCrew: [
      MOCK_WORKERS[0], MOCK_WORKERS[1], MOCK_WORKERS[2],
      MOCK_WORKERS[3], MOCK_WORKERS[4], MOCK_WORKERS[5],
    ],
    assignedAssets: [MOCK_ASSETS[0], MOCK_ASSETS[3]], // Ute K001 + Truck T2
  },
];
